export const TRAINING_HIDE_WORD_STORAGE_KEY = "vocabularium_training_hide_word";

export function readTrainingHideWord() {
  try {
    return localStorage.getItem(TRAINING_HIDE_WORD_STORAGE_KEY) === "true";
  } catch {
    // ignore quota / privacy mode errors
  }
  return false;
}

export function writeTrainingHideWord(hidden) {
  try {
    localStorage.setItem(TRAINING_HIDE_WORD_STORAGE_KEY, hidden ? "true" : "false");
  } catch {
    // ignore quota / privacy mode errors
  }
}
